var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_448_1378)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.49997C10.4087 1.49997 8.88258 2.13211 7.75736 3.25733C6.63214 4.38255 6 5.90867 6 7.49997C6 9.09127 6.63214 10.6174 7.75736 11.7426C8.88258 12.8678 10.4087 13.5 12 13.5C13.5913 13.5 15.1174 12.8678 16.2426 11.7426C17.3679 10.6174 18 9.09127 18 7.49997C18 5.90867 17.3679 4.38255 16.2426 3.25733C15.1174 2.13211 13.5913 1.49997 12 1.49997ZM4.5 7.49997C4.50002 6.04859 4.92116 4.6284 5.71234 3.41162C6.50352 2.19485 7.63076 1.23379 8.95734 0.644978C10.2839 0.0561711 11.7528 -0.135078 13.186 0.0944258C14.6191 0.32393 15.9548 0.964326 17.0312 1.93795C18.1076 2.91157 18.8783 4.17659 19.2499 5.57958C19.6216 6.98257 19.5782 8.46325 19.125 9.84206C18.6717 11.2209 17.8282 12.4385 16.6966 13.3474C15.5651 14.2563 14.1941 14.8173 12.75 14.9625V18H15.75C15.9489 18 16.1397 18.079 16.2803 18.2196C16.421 18.3603 16.5 18.5511 16.5 18.75C16.5 18.9489 16.421 19.1396 16.2803 19.2803C16.1397 19.421 15.9489 19.5 15.75 19.5H12.75V23.25C12.75 23.4489 12.671 23.6396 12.5303 23.7803C12.3897 23.921 12.1989 24 12 24C11.8011 24 11.6103 23.921 11.4697 23.7803C11.329 23.6396 11.25 23.4489 11.25 23.25V19.5H8.25C8.05109 19.5 7.86032 19.421 7.71967 19.2803C7.57902 19.1396 7.5 18.9489 7.5 18.75C7.5 18.5511 7.57902 18.3603 7.71967 18.2196C7.86032 18.079 8.05109 18 8.25 18H11.25V14.9625C9.40003 14.7765 7.68506 13.9101 6.43782 12.5312C5.19058 11.1523 4.49998 9.35926 4.5 7.49997Z",
    fill: "#52DE97"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_448_1378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.d89a9ee6bd18b4dc6105a561149f925d.svg";
export { ForwardRef as ReactComponent };